<template>
  <div class="is-light">
    <sticky class="page-header sticky-page-header page-header--new"
            :back-button="true" :forceGoBack="{name: 'Home'}">
      <div slot="left">
        <h1 class="title is-3">Notification(s)</h1>
      </div>
      <!-- <div class="column is-paddingless is-border-left" slot="right-content">
        <a @click="removeAllEvents" class="page-header-btn is-small">
          <span class="icon"><i class="fas fa-trash-alt is-size-5"></i></span>
          <span class="">Tout supprimer</span>
        </a>
      </div> -->
      <div class="dropdown-item" slot="dropdown-content">
        <a @click="loadItems()">
          <span class="icon"><i class="fas fa-sync"></i></span>
          <span>Actualiser</span>
        </a>
      </div>
    </sticky>
    <spinner-round :loading="loading" v-if="loading"></spinner-round>
    <div v-else>
      <div class="is-padding-left-on-btn-actions is-padding-right-on-btn-actions column evenementsList" v-if="timeline && timeline.length">
        <transition-group
          class="column is-paddingless is-12 is-border has-bg-white"
          enter-active-class="animista enter"
          leave-active-class="animista exit"
          move-class="transition"
          tag="div">        
          <template v-for="(e, idx) in timeline">
            <div class="column has-bg-light is-border-bottom is-size-7 has-text-grey evenementsList-groupHeader"
            :class="{'is-border-top' : idx !== 0}"
            v-if="e.showDayLabel"
            :key="e.event.pk + Date.now()">
              <strong>{{ e.date | dtFormat('dddd') | cap }} {{ e.date | dtFormat('DD')}} {{ e.date | dtFormat('MMMM') |
                cap}}</strong>
            </div>
            <event-row :key="e.event.pk" :event="e.event" @remove="deleteItem"></event-row>
          </template>
        </transition-group>
      </div>
      <div v-else class="column">
        Pas de notification
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { GenericList, Filter, DefaultValues } from '../../mixins'
  import EventRow from './EventRow'
  import moment from 'moment'

  export default {
    name: 'EventList',
    components: {
      EventRow
    },
    mixins: [GenericList, Filter, DefaultValues],
    filters: {
      truncate (value) {
        return value.length >= 50 ? value.substring(0, 50) + '...' : value
      }
    },
    data () {
      return {
        service: this.$api.eventService,
        loadDocuments: this.loadItems,
        loading: false
      }
    },
    computed: {
      ...mapGetters(['orderedEvents']),
      ...mapState([
        'events',
        'currentUser'
      ]),
      exitAnimationClass () {
        if (this.orderedEvents.length < 15) {
          return 'animista exit'
        } else {
          return null
        }
      },
      timeline () {
        let timeline = []
        if (this.listedEvents && this.listedEvents.length) {
          return this.listedEvents.map(x => {
            let date = moment(x.date).format('DD/MM/YYYY')
            if (timeline.includes(date) === false) {
              this.$set(x, 'showDayLabel', true)
              timeline.push(date)
            }
            return x
          })
        }
      },
      listedEvents () {
        return this.orderedEvents.map(x => {
          return {
            event: Object.assign({}, x),
            date: x.created_on,
            showDayLabel: false
          }
        })
      }
    },
    methods: {
      removeAllEvents () {
        this.loading = true
        this.$api.eventService.deleteMany().then(() => {
          this.loading = false
          this.$notify({
            type: 'is-success',
            text: 'Les notifications sont en cours de suppression.'
          })
          this.loadItems()
        }).catch(() => {
          this.loading = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la suppression des notifications.'
          })
        })
      },
      confirmDelete () {
        // Fake promise to emulate sweetAlter promise Behavior
        return new Promise(function (resolve, reject) {
          resolve({value: true})
        })
      },
      afterSuccessGet (r) {
        this.$store.commit('setEvents', {events: r.data})
      }
    },
    created () {
      this.loadItems()
    }
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/event/EventList.vue